import React from 'react';

import aboutImg from '../../../assets/images/aboutKPlots.webp'
import aboutBg from '../../../assets/images/aboutBg.webp'

const path = "/keralaplots/";

function AboutUs() {

  return (
    <>

        {/* about page */}
        <section id="aboutPage">
            <div className="container">
                <div className="aboutPageMain">
                  <h2>keralaplots.com</h2>
                  <h2>malayali's realestate partner</h2>
                  <div className="aboutBannerImg">
                    <img src={aboutImg} alt="" />
                  </div>
                  <div className="aboutMission">
                    <h2>On a Mission towards growth</h2>
                    <p>We are industry leaders in providing Malayalees around the globe with online real estate advertisement services. Builders, real estate agents, sellers, and landlords can all advertise their listings on KeralaPlots.com together. It also serves as a source of information and a platform for potential buyers from around the world who want to look for land, real estate, or housing in Kerala and take advantage of allied services.</p>
                    <div className="aboutMissionImg">
                      <img src={aboutBg} alt="" />
                    </div>
                    <p>We provide our users with a comprehensive and simple search tool that enables them to find their desired property by region, area, price, amenities, and availability. We stay current on all the most recent market developments and trends so that we can respond to all of your enquiries, keep you informed over time, and increase the value of your properties through our experience and knowledge. We provide potential customers and investors with opportunities to invest in Kerala real estate. With regard to buying, selling, renting, and leasing of Land/Property, we provide all types of information, advice, and services on the Kerala real estate market. In addition, we assist clients in selecting appropriate land or property in accordance with their needs and budget by responding to their questions about any aspect of real estate.</p>
                  </div>
                </div>
            </div>
        </section>
        {/* about page close */}

    </>
  );
}

export default AboutUs;
